import React, {Component} from 'react';
import {Route, Switch, withRouter, Redirect} from 'react-router-dom';

import {getUser} from "../../utils/TokenManager";
import TopNav from '../staffDashboardNav/TopNav';
import SideNav from '../staffDashboardNav/SideNav';
import StaffDashboardService from "../../services/StaffDasboardService";
import DashboardVideo from "./DashboardVideo";
import HomeContainer from "../../containers/StaffDashboardContainer";
import AgencyMonitorDashboard from  "../../containers/AgencyMonitor/AgencyMoniorDashboard"
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import * as AuthAction from "../../actions/AuthAction";
import * as AuditAction from "../../actions/ComplianceAuditAction";
import * as StaffDashboardAction from "../../actions/StaffDashboardAction";
import * as ReportAction from "../../actions/ReportAction";
import * as PTOAction from "../../actions/PTOAction";
import ZendeskSupport from "../common/Zendesk";


class StaffDashboard extends Component {
    state = {
        fullSideBar: false,
        user: {},
        showperformacereport: false,
    }

    componentDidMount = () => {
        const user = getUser();
        this.setState({user});
        this.getUserCompensation();
    }

    clickNavBox = () => {
        this.setState({fullSideBar: false});
        return false;
    };

    toggleSideNav = () =>{
        this.setState((prevProps) => ({fullSideBar: !prevProps.fullSideBar}));
    }

    openSideBar = () => {
        this.setState({fullSideBar: true});
        return false;
    }

    updateVideoSeenStatus = () => {
        const user = getUser();
        this.setState({user});
    }
    
    getUserCompensation = async () => {
        try {
            let result = await StaffDashboardService.getStaffCompensationList();
            

            if (result) {
                  //let compensationProfileList = result.map(profile => ({...profile}));  
                var count = Object.keys(result.data).length;
                if (count > 0) {
                    this.setState({showperformacereport:true});
                }
            }            
        } catch (error) {
           // toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
        }
    };

      
    render() {
        const {fullSideBar, user} = this.state;
        return (
            user.seen_dashboard_video ?
            window.location.pathname!='/agency-monitor-staff' ?
                <div className="main-wrapper">
                    <TopNav history={this.props.history} 
                        fullSideBar={fullSideBar} 
                        toggleSideNav={this.toggleSideNav}
                    />
                    
                    <SideNav {...this.props}
                    fullSideBar={fullSideBar} 
                    openSideBar={this.openSideBar}
                    showperformacereport = {this.state.showperformacereport}

                    />
                    
                    
                    <div className={`page-wrapper ${fullSideBar ? "full" : "mini"}`} 
                        onClick={this.clickNavBox}
                        style={{top: "54px"}}
                    >
                        <Switch>
                            <Route path='/agency-monitor-staff'
                                render={(props) => 
                                    <AgencyMonitorDashboard {...props} isStaff={true} />
                                }
                            />

                            <Route path='/home' 
                                render={(props) => <HomeContainer {...props} isStaff={true} />}
                            />
                            
                            <Route render={() => <Redirect to="/home" />}/>
                        </Switch>
                    </div>
                    <ZendeskSupport />
                </div>
                : <div>
                     <AgencyMonitorDashboard {...this.props} isStaff={true} />
                </div>
                
            :
                <DashboardVideo {...this.props} 
                    updateStatusInStore={this.updateVideoSeenStatus} 
                />
            
                
            
        )
    }
}

function mapStateToProps(state) {
    return {
        agencyLocation: state.AgencyLocationReducer,
        staffDashboard: state.StaffDashboardReducer,
        report: state.ReportReducer,
        pto: state.PTOReducer,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        Object.assign(
            {}, AuthAction, AuditAction, StaffDashboardAction, 
            ReportAction, PTOAction, 
        ), 
        dispatch
    );
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StaffDashboard));



// WEBPACK FOOTER //
// ./src/components/staffDashboard/MainDashboard.js